import {gql, useMutation} from "@apollo/client";

const ADD_DIVISION_MUTATION = gql`
mutation AddDivision($name: String!, $orgSlug: String!, $sport: String, $competitionLevel: String, $ageGroup: String, $mountDistance: Float, $pitchLimit: Int, $restingGames: Int, $waiverIds: [ID], $gameDuration: Int) {
  createDivision(name: $name, orgSlug: $orgSlug, sport: $sport, competitionLevel: $competitionLevel, ageGroup: $ageGroup, mountDistance: $mountDistance, pitchLimit: $pitchLimit, restingGames: $restingGames, waiverIds: $waiverIds, gameDuration: $gameDuration) {
    division {
      id
      slug
      name
      competitionLevel
      ageGroup
      description
      logo
      mountDistance
      pitchLimit
      gameDuration
      restingGames
      sport{
        key
        name
      }
      isOpen
      organization{
        name
      }
      activeSeason {
        id
        slug
        name
        registrationStartDate
        registrationEndDate
        startDate
        endDate
        state
      }
      seasons {
        id
        name
        slug
      }
      waivers {
            id
            title
        }
    }
  }
}
`;

export default function AddDivisionMutation() {
    return useMutation(ADD_DIVISION_MUTATION);
}
